module.exports = __webpack_public_path__ + "static/media/step1.ccaae3ab.webp";